import { useEffect, useState } from "react";
import { ArrowLeft, Search, X } from 'lucide-react';
import { CategoryResponse } from '@/js/repository/CategoryRepository';
import { useTranslation } from "react-i18next";
import Header from "./Header";
import { SiteInfo } from "@/globals";

export default function Layout({ children, categories }: any) {
  const [showModal, setShowModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { t } = useTranslation();
  
  return (
    <>
      <Header categories={categories} setShowModal={setShowModal} setShowSearchModal={setShowSearchModal} />
      
      <main className="justify-center max-w-[1280px] min-h-[calc(100vh-60px-96px)]
        pt-[84px] p-[16px] sm:pt-[84px] sm:p-[24px] mx-auto mt-2">
        { children }
      </main>

      {/* 모달 */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 text-white">
          <div className="bg-black w-full h-full p-6 overflow-auto">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4"
              title={t("close")}
            >
              <X size={24} />
            </button>
            <a href="/" className="block text-[#fd384f] font-bold text-xl mb-6" onClick={() => setShowModal(false)}>
              {SiteInfo.siteName}
            </a>

            <a href="/brands" className="block font-bold text-xl mb-6 text-red-300" onClick={() => setShowModal(false)}>
              {t("brands")}
            </a>

            <ul className="mt-6 space-y-4">
              {categories.map((category: CategoryResponse) => (
                <li key={category.id} className="text-lg">
                  <a href={`/products?category=${category.id}`} onClick={() => setShowModal(false)}>{category.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* 검색 모달 */}
      {showSearchModal && (
        <div className="fixed inset-0 z-50 bg-black/60 text-white">
          <div className="w-full flex flex-wrap items-center h-[60px] bg-black">
            <button
              onClick={() => setShowSearchModal(false)}
              className="mx-4"
              title={t("close")}
            >
              <ArrowLeft size={24} />
            </button>

            <form action="/search" method="get" className="flex flex-grow">
              <input
                type="search"
                name="q"
                className="w-full h-10 px-3 rounded bg-white text-black"
                placeholder={t("search")}
              />

              <button
                type="submit"
                className="mx-4"
                title={t("close")}
              >
                <Search size={20} />
              </button>

            </form>
          </div>
          {/* scroll이 되도록 css 수정 */}
          <div className="w-full h-[calc(100%-60px)] overflow-auto" onClick={() => setShowSearchModal(false)}>
            {/* <ul className="">
              {categories.map((category: CategoryResponse) => (
                <li key={category.id} className="text-lg text-black p-2">
                  <a href={`/products?category=${category.id}`} onClick={() => setShowSearchModal(false)}>{category.name}</a>
                </li>
              ))}
            </ul> */}
          </div>
        </div>
      )}
    </>
  );
}